var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.78899 7.02975C5.30023 5.40843 7.45306 4.5 9.9975 4.5H26.001C28.5514 4.5 30.7052 5.40795 32.2157 7.03017C33.7178 8.64333 34.5 10.8714 34.5 13.374V21.126C34.5 23.6286 33.7178 25.8567 32.2155 27.4699C30.7047 29.0921 28.5506 30 25.9995 30H9.9975C7.44704 30 5.29359 29.092 3.78343 27.4697C2.28173 25.8565 1.5 23.6284 1.5 21.126V13.374C1.5 10.8702 2.28594 8.64229 3.78899 7.02975ZM5.43488 8.56388C4.38456 9.69071 3.75 11.3373 3.75 13.374V21.126C3.75 23.1641 4.38202 24.8105 5.43032 25.9367C6.47016 27.0537 8.00296 27.75 9.9975 27.75H25.9995C27.9949 27.75 29.5285 27.0536 30.5689 25.9365C31.6177 24.8103 32.25 23.1639 32.25 21.126V13.374C32.25 11.3361 31.6177 9.68967 30.569 8.56346C29.5288 7.4463 27.9956 6.75 26.001 6.75H9.9975C8.01044 6.75 6.47702 7.44582 5.43488 8.56388Z",
    fill: "#221AFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1546",
    d: "M3 10.5H33V13.5H3V10.5Z",
    fill: "#221AFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1547",
    d: "M22.5 24C22.5 23.1716 23.1716 22.5 24 22.5H27C27.8284 22.5 28.5 23.1716 28.5 24C28.5 24.8284 27.8284 25.5 27 25.5H24C23.1716 25.5 22.5 24.8284 22.5 24Z",
    fill: "#221AFB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit_card.90d02f5456827f6321f98154c8e6da67.svg";
export { ForwardRef as ReactComponent };